(function () {
  const STORAGE_PREFIX = 'bcFirstDibs:v1';
  const DISMISSED_KEY = `${STORAGE_PREFIX}:dismissedAt`;
  const COMPLETED_KEY = `${STORAGE_PREFIX}:completed`;
  const SESSION_KEY = `${STORAGE_PREFIX}:shown`;
  const SHOWN_AT_KEY = `${STORAGE_PREFIX}:shownAt`;

  function storageGet(storage, key) {
    try {
      return window[storage].getItem(key);
    } catch (_) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      window[storage].setItem(key, value);
    } catch (_) {
      // Privacy modes can disable storage. The signup still works without it.
    }
  }

  function measurementAllowed() {
    if (navigator.globalPrivacyControl === true) return false;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return Boolean(privacy && privacy.analyticsProcessingAllowed()); }
    catch (_) { return false; }
  }

  function track(root, action) {
    if (!Array.isArray(window.dataLayer) || !measurementAllowed()) return;
    try {
      window.dataLayer.push({
        event: `bc_email_flyout_${action}`,
        bc_page_type: root.dataset.bcPageType || '',
      });
    } catch (_) {}
  }

  function initEmailFlyout(root) {
    if (!root || root.dataset.bcInitialized === 'true') return;
    root.dataset.bcInitialized = 'true';

    const closeButton = root.querySelector('[data-bc-email-close]');
    const reopenButton = document.querySelector('[data-bc-email-reopen]');
    const form = root.querySelector('form');
    const submitButton = root.querySelector('[data-bc-email-submit]');
    const success = root.querySelector('[data-bc-email-success]');
    const serverError = root.querySelector('[data-bc-email-error]');
    if (!closeButton || !reopenButton) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const designMode = root.dataset.bcDesignMode === 'true';
    const delay = Math.max(0, Number(root.dataset.bcDelay || 5)) * 1000;
    const scrollThreshold = Math.min(90, Math.max(10, Number(root.dataset.bcScroll || 45))) / 100;
    const dismissDays = Math.max(1, Number(root.dataset.bcDismissDays || 14));
    const triggerMode = root.dataset.bcTrigger || 'delay';
    const launchMode = root.dataset.bcMode === 'launch';
    const snoozeDays = Math.max(1, Number(root.dataset.bcSnoozeDays || 3));
    const phoneField = root.querySelector('[data-bc-email-phone]');
    const tagsField = root.querySelector('input[name="contact[tags]"]');
    let openTimer = null;
    let shown = false;
    let previousFocus = null;
    const measurementKey = `${STORAGE_PREFIX}:measurement:${form ? form.id : 'flyout'}`;

    function beginMeasurement(step) {
      if (!measurementAllowed()) {
        try { window.sessionStorage.removeItem(measurementKey); } catch (_) {}
        return;
      }
      storageSet('sessionStorage', measurementKey, JSON.stringify({ step, at: Date.now() }));
    }

    function completeMeasurement(step) {
      let pending;
      try {
        pending = JSON.parse(storageGet('sessionStorage', measurementKey) || 'null');
        window.sessionStorage.removeItem(measurementKey);
      } catch (_) { return; }
      if (!pending || pending.step !== step || !Number.isFinite(pending.at)) return;
      const elapsed = Date.now() - pending.at;
      if (elapsed < 0 || elapsed > 30 * 60 * 1000) return;
      track(root, step === 'sms' ? 'sms_success' : 'success');
    }

    if (serverError) {
      try { window.sessionStorage.removeItem(measurementKey); } catch (_) {}
    }

    function setExpanded(expanded) {
      reopenButton.setAttribute('aria-expanded', String(expanded));
    }

    function show(options = {}) {
      if (shown && !root.hidden) return;
      shown = true;
      const activeElement = document.activeElement;
      previousFocus = activeElement instanceof HTMLElement && !root.contains(activeElement) ? activeElement : null;
      window.clearTimeout(openTimer);
      window.removeEventListener('scroll', onScroll);
      root.hidden = false;
      document.documentElement.classList.add('bc-flyout-open');
      reopenButton.hidden = true;
      setExpanded(true);
      storageSet('sessionStorage', SESSION_KEY, 'true');
      if (!options.reopen) storageSet('localStorage', SHOWN_AT_KEY, String(Date.now()));
      window.requestAnimationFrame(() => {
        root.dataset.state = 'open';
        if (options.focusSuccess && success) success.focus({ preventScroll: true });
      });
      track(root, options.reopen ? 'reopen' : 'view');
    }

    function finishHide() {
      const shouldRestoreFocus = root.contains(document.activeElement);
      root.hidden = true;
      document.documentElement.classList.remove('bc-flyout-open');
      reopenButton.hidden = true;
      setExpanded(false);
      if (shouldRestoreFocus && previousFocus?.isConnected && previousFocus.getClientRects().length &&
          !previousFocus.closest('[hidden], [inert]') && !previousFocus.matches(':disabled')) {
        previousFocus.focus({ preventScroll: true });
      }
      previousFocus = null;
    }

    function hide() {
      root.dataset.state = 'closed';
      storageSet('localStorage', DISMISSED_KEY, String(Date.now()));
      track(root, 'dismiss');
      if (reduceMotion) {
        finishHide();
      } else {
        window.setTimeout(finishHide, 230);
      }
    }

    function interactionInProgress() {
      const active = document.activeElement;
      const isTyping = active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
      const hasOpenDialog = Boolean(document.querySelector('dialog[open], [aria-modal="true"]:not([hidden])'));
      return isTyping || hasOpenDialog;
    }

    function showWhenClear() {
      if (interactionInProgress()) {
        openTimer = window.setTimeout(showWhenClear, 1200);
        return;
      }
      show();
    }

    function pageProgress() {
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      return maxScroll > 0 ? window.scrollY / maxScroll : 0;
    }

    function onScroll() {
      if (pageProgress() >= scrollThreshold) showWhenClear();
    }

    function clearGates() {
      try {
        window.localStorage.removeItem(SHOWN_AT_KEY);
        window.localStorage.removeItem(DISMISSED_KEY);
        window.localStorage.removeItem(COMPLETED_KEY);
        window.sessionStorage.removeItem(SESSION_KEY);
      } catch (_) {}
    }

    const previewButton = document.querySelector('[data-bc-email-preview]');
    if (previewButton && previewButton.hasAttribute('data-bc-preview-auto')) {
      // Any theme but the live one: a preview link, an unpublished theme, the theme editor.
      const role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      if ((role && role !== 'main') || designMode) previewButton.hidden = false;
    }
    if (previewButton) {
      previewButton.addEventListener('click', function () {
        // Clear every gate so the pop-up can be re-checked on demand while reviewing.
        clearGates();
        shown = false;
        show({ reopen: true });
        closeButton.focus({ preventScroll: true });
      });
    }

    closeButton.addEventListener('click', hide);
    reopenButton.addEventListener('click', function () {
      show({ reopen: true });
      closeButton.focus({ preventScroll: true });
    });

    const steps = root.querySelector('[data-bc-fd]');
    if (form && submitButton && steps) {
      wireTwoStep();
    } else if (form && submitButton) {
      form.addEventListener('submit', function () {
        if (!form.checkValidity()) return;
        if (phoneField && tagsField) {
          // A blank phone must not post an empty contact[phone]; a real one is tagged
          // so the SMS list can be pulled even if the storefront form drops the field.
          const digits = phoneField.value.replace(/\D/g, '');
          if (digits.length >= 10) {
            tagsField.value += ',sms-optin';
          } else {
            phoneField.disabled = true;
          }
        }
        const label = submitButton.querySelector('span');
        if (label) {
          submitButton.dataset.defaultLabel = label.textContent;
          label.textContent = submitButton.dataset.loadingLabel || 'Joining…';
        }
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        beginMeasurement('email');
        track(root, 'submit');

        window.setTimeout(function () {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
          if (label && submitButton.dataset.defaultLabel) label.textContent = submitButton.dataset.defaultLabel;
        }, 10000);
      });
    }

    /* The launch sign-up, in two steps, each an ordinary form post.
     *
     * Shopify guards this form with hCaptcha: its script takes over the submit and sends a real
     * one once it has a token, so nothing here posts in the background. This listens in the
     * capture phase, on the card, so it runs before Shopify's handler on the form does - which
     * is also what lets it stop a bad phone number from being sent at all.
     *
     * Step one stores the email (sessionStorage) and lets the post go. Shopify returns to the same
     * page with the form marked posted; the card reopens on step two with the email in a hidden
     * field. Step two normalises the number to +1XXXXXXXXXX, tags the post sms-optin and lets it
     * go; when Shopify returns, the card shows the thank-you. */
    function wireTwoStep() {
      const PENDING_KEY = `${STORAGE_PREFIX}:pending`;
      const EMAIL_KEY = `${STORAGE_PREFIX}:email`;
      const phoneError = root.querySelector('[data-bc-fd-phone-error]');
      const skip = root.querySelector('[data-bc-fd-skip]');
      const emailField = root.querySelector('[data-bc-fd-email]');

      function goTo(name) {
        steps.querySelectorAll('[data-bc-fd-step]').forEach(function (step) {
          step.hidden = step.dataset.bcFdStep !== name;
        });
        steps.dataset.step = name;
        const target = steps.querySelector('[data-bc-fd-step="' + name + '"]');
        const focusable = target && target.querySelector('[data-bc-fd-focus]');
        window.requestAnimationFrame(function () {
          if (focusable) focusable.focus({ preventScroll: true });
        });
      }

      // A US number typed any way at all, as +1XXXXXXXXXX; a number already in + form is kept.
      function e164(value) {
        const digits = value.replace(/\D/g, '');
        if (digits.length === 10) return '+1' + digits;
        if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
        if (value.trim().charAt(0) === '+' && digits.length >= 8) return '+' + digits;
        return '';
      }

      function markBusy() {
        const button = steps.querySelector('[data-bc-fd-step]:not([hidden]) [data-bc-email-submit]');
        const label = button && button.querySelector('span');
        if (!button) return;
        const original = label ? label.textContent : '';
        if (label) label.textContent = button.dataset.loadingLabel || 'Saving…';
        button.setAttribute('aria-busy', 'true');
        // If the captcha is dismissed or stalls, give the button back rather than leave it saving.
        window.setTimeout(function () {
          if (label && original) label.textContent = original;
          button.removeAttribute('aria-busy');
        }, 8000);
      }

      root.addEventListener('submit', function (event) {
        const step = steps.dataset.step;
        if (step === 'email') {
          if (!form.checkValidity()) return;
          storageSet('sessionStorage', EMAIL_KEY, emailField ? emailField.value.trim() : '');
          storageSet('sessionStorage', PENDING_KEY, 'email');
          beginMeasurement('email');
          track(root, 'submit');
          markBusy();
          return;
        }
        if (step === 'phone') {
          const phone = phoneField ? e164(phoneField.value) : '';
          if (!phone) {
            event.preventDefault();
            event.stopPropagation();
            if (phoneError) phoneError.hidden = false;
            if (phoneField) {
              phoneField.setAttribute('aria-invalid', 'true');
              phoneField.focus();
            }
            return;
          }
          const consent = root.querySelector('[data-bc-fd-sms-consent]');
          const consentError = root.querySelector('[data-bc-fd-consent-error]');
          if (consent && !consent.checked) {
            event.preventDefault();
            event.stopPropagation();
            if (consentError) consentError.hidden = false;
            consent.focus();
            return;
          }
          phoneField.value = phone;
          if (tagsField && tagsField.value.indexOf('sms-optin') === -1) {
            // What was agreed to, and when: the consent record a text platform will ask for.
            const day = new Date().toISOString().slice(0, 10);
            tagsField.value += ',sms-optin,sms-consent-popup-v1,sms-consent-' + day;
          }
          storageSet('sessionStorage', PENDING_KEY, 'phone');
          beginMeasurement('sms');
          track(root, 'sms_submit');
          markBusy();
        }
      }, true);

      const consentBox = root.querySelector('[data-bc-fd-sms-consent]');
      if (consentBox) {
        consentBox.addEventListener('change', function () {
          const consentError = root.querySelector('[data-bc-fd-consent-error]');
          if (consentError && consentBox.checked) consentError.hidden = true;
        });
      }

      if (phoneField) {
        phoneField.addEventListener('input', function () {
          if (phoneError && !phoneError.hidden) phoneError.hidden = true;
          phoneField.removeAttribute('aria-invalid');
        });
      }

      if (skip) {
        skip.addEventListener('click', function () {
          try { window.sessionStorage.removeItem(PENDING_KEY); } catch (_) {}
          track(root, 'sms_skip');
          goTo('done');
        });
      }

      // Back from Shopify after a post.
      if (steps.hasAttribute('data-bc-email-success')) {
        const pending = storageGet('sessionStorage', PENDING_KEY);
        try { window.sessionStorage.removeItem(PENDING_KEY); } catch (_) {}
        storageSet('localStorage', COMPLETED_KEY, 'true');
        if (pending === 'phone') {
          completeMeasurement('sms');
          goTo('done');
          return;
        }
        completeMeasurement('email');
        if (emailField && !emailField.value) emailField.value = storageGet('sessionStorage', EMAIL_KEY) || '';
        // Without the email there is nothing to attach a number to; thank them instead.
        if (!emailField || !emailField.value) goTo('done');
      } else if (steps.dataset.step === 'phone' && emailField && !emailField.value) {
        // Shopify sent the phone step back with an error; the email rides along from step one.
        emailField.value = storageGet('sessionStorage', EMAIL_KEY) || '';
      }
    }

    if (success) {
      storageSet('localStorage', COMPLETED_KEY, 'true');
      if (!steps) completeMeasurement('email');
      show({ focusSuccess: true });
      return;
    }

    if (serverError || designMode) {
      show();
      return;
    }

    const params = new URLSearchParams(window.location.search);
    if (params.has('first-dibs') || window.location.hash === '#first-dibs') {
      // Open it, but leave the memory alone: a subscriber who taps the link is not asked again later.
      openTimer = window.setTimeout(function () { show(); }, 400);
      return;
    }

    if (storageGet('localStorage', COMPLETED_KEY) === 'true') return;

    const dismissedAt = Number(storageGet('localStorage', DISMISSED_KEY) || 0);
    const dismissalIsCurrent = dismissedAt && Date.now() - dismissedAt < dismissDays * 86400000;
    if (launchMode) {
      // Launch mode: show once on any page, then wait `snoozeDays` before showing again until completed.
      const shownAt = Number(storageGet('localStorage', SHOWN_AT_KEY) || 0);
      if (shownAt && Date.now() - shownAt < snoozeDays * 86400000) return;
    } else if (dismissalIsCurrent || storageGet('sessionStorage', SESSION_KEY) === 'true') return;

    if (triggerMode === 'delay' || triggerMode === 'whichever') {
      openTimer = window.setTimeout(showWhenClear, delay);
    }
    if (triggerMode === 'scroll' || triggerMode === 'whichever') {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bc-email-flyout]').forEach(initEmailFlyout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initEmailFlyout(event.target.querySelector('[data-bc-email-flyout]'));
  });
})();
